import { PAPER_ELEMENT_TYPE } from '../../../../shared/constants/drawable-types'
import store from '../../../../stores'
import { resetActiveFlagAction } from '../../../sagas/2D/resetActiveFlag'
import { setActiveFlagAction } from '../../../sagas/2D/setActiveFlag'
import { updateFlagCoordinatesAction } from '../../../sagas/2D/updateFlagOpeningCoordinates'
import { hideFlagDetails } from '../../../slices/materialFlags'

function save2DFlagEdits() {
    return function saveFlag(this: paper.Item) {
        store.dispatch(
            updateFlagCoordinatesAction({ id: this.data.flag_id, openingId: this.data.openingId, paperId: this.id })
        )
    }
}

function select2DFlag(): () => void {
    return function selectFlag(this: paper.Item) {
        store.dispatch(resetActiveFlagAction({}))
        store.dispatch(hideFlagDetails())

        store.dispatch(
            setActiveFlagAction({
                flag_id: this.data.flag_id,
                paperId: this.id,
            })
        )
    }
}

function deselect2DFlag(): () => void {
    return function deselectFlag(this: paper.Item) {
        store.dispatch(resetActiveFlagAction({ is2DFlagDeselected: true }))
        store.dispatch(hideFlagDetails())
    }
}

export default function addSelectFunctionalityToFlag(path: paper.Item): void {
    path.data.type = PAPER_ELEMENT_TYPE.FLAG
    path.data.onSelect = select2DFlag().bind(path)
    path.data.onDeselect = deselect2DFlag().bind(path)
    path.data.onSave = save2DFlagEdits().bind(path)
}
